module.exports = webappBundle("configuration/workday/wizard/wizard.css");